import React, { useState } from "react";
import { CalculationResult } from "../../models/CalculationResult";

export type CalculationResultProps = {
  model: CalculationResult;
  translations: {[key: string]: string}
};

export const CalculationResults: React.FC<CalculationResultProps> = ({
  model: { totalAmount, children },
  translations = {},
}) => {
  const [open, setOpen] = useState<{ [key: number]: boolean }>({});

  function toggle(idx: number) {
    setOpen((state) => ({ ...state, [idx]: !state[idx] }));
  }

  return (
    <div className="mb-3 border-bottom pb-3">
      {children.map((child, idx) => (
        <div key={`${child.name}_${idx}`}>
          {idx > 0 && <div className="border-top border-ecru-dark-25 my-1"></div>}

          <div className="position-relative pt-1 pb-2 d-flex flex-row align-items-center">
            <div>{child.name}</div>
            <button
              type="button"
              className="btn btn-link p-0 stretched-link"
              onClick={() => toggle(idx)}
              aria-label="open"
            >
              <img
                className={`ml-1 ${open[idx] ? "rotate-180" : ""}`}
                src="/img/svg/icon-chevron-grey.svg"
                alt=""
              />
            </button>
            <div className="ml-auto font-weight-bold">{child.totalAmount}€</div>
          </div>

          {open[idx] ? <div className="mb-3">
            {child.breakdown.filter(item => item.amount !== 0).map(item => (
              <div key={item.type} className="text-brown-60 d-flex flex-row align-items-center text-medium my-1">
                <span className="mr-auto">{translations[`Type.${item.type}`]}</span>
                <span>{item.amount}€</span>
              </div>
            ))}
          </div> : null}
        </div>
      ))}
      <div className="pt-2 border-brown-25-alpha border-top-dashed d-flex flex-row align-items-center">
        <div className="mr-auto font-weight-bold">{translations[`Total`]}</div>
        <div className="ml-auto m-0 h4">{totalAmount}€</div>
      </div>
    </div>
  );
};
